import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { SpriteResource } from "../ResourceManager/SpriteResource";
import { LogGroup, CreateElement, Scale, Size, SetStyles, Style } from ".././MyHelpers";
import { FountainAnimation } from "./FountainAnimation";
import { JackpotDisplay, JackpotDisplayType, Settings } from "../Settings";
import { ZIndex } from "../ZIndex";
import { JackpotLevel } from "../api";

export class SlotGameType1Shared
{


    protected view: HTMLElement = null;

    protected resid: ResourceIdentifier = new ResourceIdentifier("Screen1", "SlotGameType1Shared");
    protected logGroup: LogGroup = new LogGroup("SlotGameType1Shared");
    protected jackpotRequired: boolean;


    // only 1 instance of this can exist!
    protected constructor() {}
    protected static instance: SlotGameType1Shared = null;
    public static Instance(): SlotGameType1Shared
    {
        if (SlotGameType1Shared.instance == null)
        {
            SlotGameType1Shared.instance = new SlotGameType1Shared();
        }

        return SlotGameType1Shared.instance;
    }




    protected lastPrepareStage: LoadingStage = LoadingStage.Idle;
    public ResourcesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
    {
        if (loadingStage == this.lastPrepareStage) return;
        this.lastPrepareStage = loadingStage;

        if (loadingStage == LoadingStage.Games)
        {
            this.ViewPrepare(resourceManager);
            this.CoinFountainPrepare(resourceManager);
        }
    }


    protected lastLoadedStage: LoadingStage = LoadingStage.Idle;
    public ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager)
    {
        if (loadingStage == this.lastLoadedStage) return;
        this.lastLoadedStage = loadingStage;

        if (loadingStage == LoadingStage.Games)
        {
            this.ViewLoaded(resourceManager);
            this.CoinFountainLoaded(resourceManager);
        }
    }





    protected ViewPrepare(resourceManager: IWriteOnlyResourceManager): void
    {
        this.view = CreateElement("div", {
            classes: ["SlotGameType1Shared"],
            style: {
                position: "absolute",
                top: (Scale.Y(-1080) * Settings.Screens) + Settings.ScreenHeight+"px",
                left: "0px",
                width: Scale.Wpx(1920),
                height: (Scale.H(1080) * Settings.Screens) + "px",
                pointerEvents: "none",
            }
        });
    }

    protected ViewLoaded(resourceManager: IReadOnlyResourceManager): void
    {

    }

    public View(): HTMLElement
    {
        return this.view;
    }

    protected PromoPrepare(resourceManager: IReadOnlyResourceManager): void
    {

    }

    protected PromoLoaded(resourceManager: IReadOnlyResourceManager): void
    {

    }

    public smallFountainAnimation: FountainAnimation = null;
    public mediumFountainAnimation: FountainAnimation = null;
    public bigFountainAnimation: FountainAnimation = null;
    public jackpotFountain: Map<JackpotLevel, FountainAnimation> = null

    protected CoinFountainPrepare(resourceManager: IWriteOnlyResourceManager): void
    {
        resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/coin_1_200x200", ResourceIdentifier.Global.Add("fountain").Add("coin"), true, LogGroup.Global.Add("fountain").Add("coin"), true));
    }

    protected CoinFountainLoaded(resourceManager: IReadOnlyResourceManager): void
    {

        let acceleration :number [] = [];
        
        if (Settings.Screens == 3) {
            acceleration = [0.65,0.78, 0.85, 0.98];
        }
        else if (Settings.Screens == 2) {
            acceleration = [0.25,0.40, 0.50, 0.65];
        }
        else if (Settings.Screens == 1) {
            acceleration = [0.30, 0.25, 0.20,0.15];
        }

        // this is big win animation
        this.smallFountainAnimation = new FountainAnimation(
			this.logGroup.Add("fountain-generic-small"),
            this.resid.Add("fountain-generic-small"),
			new Size(Scale.W(1920), (Scale.H(1080) * Settings.Screens)), 
			resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("fountain").Add("coin")).sprite, 
			new Size(Scale.W(120), Scale.H(120)),
			acceleration[3]
		);
		
		SetStyles(this.smallFountainAnimation.View(), {
            zIndex: "" + ZIndex.BonusFountain,
            position: "absolute",
            top: "0px",
            left: "0px"
        });

        this.view.appendChild(this.smallFountainAnimation.View());

        // fountain to emerald
        this.mediumFountainAnimation = new FountainAnimation(
			this.logGroup.Add("fountain-generic-medium"),
            this.resid.Add("fountain-generic-medium"),
			new Size(Scale.W(1920), (Scale.H(1080) * Settings.Screens)), 
			resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("fountain").Add("coin")).sprite, 
			new Size(Scale.W(120), Scale.H(120)),
			acceleration[2]
		);

        SetStyles(this.mediumFountainAnimation.View(), {
            zIndex: "" + ZIndex.BonusFountain,
            position: "absolute",
            top:"0px", //top: (Scale.Y(-1080) * Settings.Screens) + Settings.ScreenHeight+"px",
            left: "0px"
        });

        this.view.appendChild(this.mediumFountainAnimation.View());

        // fountain to sapphire
        this.bigFountainAnimation = new FountainAnimation(
            this.logGroup.Add("fountain-generic-big"),
            this.resid.Add("fountain-generic-big"),
			new Size(Scale.W(1920),(Scale.H(1080) * Settings.Screens)), 
			resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("fountain").Add("coin")).sprite, 
			new Size(Scale.W(120), Scale.H(120)),
			acceleration[0]
		);
        SetStyles(this.bigFountainAnimation.View(), {
            zIndex: "" + ZIndex.BonusFountain,
            position: "absolute",
            top:"0px",//top: (Scale.Y(-1080) * Settings.Screens) + Settings.ScreenHeight+"px",
            left: "0px"
        });

        this.view.appendChild(this.bigFountainAnimation.View());

        this.jackpotFountain = new Map<JackpotLevel, FountainAnimation>();
        this.jackpotFountain.set(JackpotLevel.Jp1, this.smallFountainAnimation);
        this.jackpotFountain.set(JackpotLevel.Jp2, this.smallFountainAnimation);
        this.jackpotFountain.set(JackpotLevel.Jp3, this.mediumFountainAnimation);
        this.jackpotFountain.set(JackpotLevel.Jp4, this.bigFountainAnimation);
    }


    public Update(): void {
        this.smallFountainAnimation.Update();
        this.mediumFountainAnimation.Update();
        this.bigFountainAnimation.Update();
    }
}